<template src="./nav.html"></template>
<script>
export default {
  name: "navigation",
  data() {
    return {
      products: [],
      system: [],
      user: [],
      productSearchTerm: "",
      searchResults: []
    };
  },
  methods: {
    searchProduct: function() {
      this.searchResults = [];
      // regex products against search term and display list
      if (this.productSearchTerm != "") {
        for (var i = 0; i < this.products.length; i++) {
          if (
            this.products[i].name
              .toLowerCase()
              .indexOf(this.productSearchTerm.toLowerCase()) !== -1
          ) {
            this.searchResults.push(this.products[i]);
          }
        }
      }
    },
    clearSearch: function(event) {
      if (event.relatedTarget != null) {
        if (event.relatedTarget.className != null) {
          if (event.relatedTarget.className != "agentColour2TextHover") {
            this.searchResults = [];
          }
        }
      } else {
        this.searchResults = [];
      }
    },
    fetch() {
      // fetch the products
      this.axios
        .get("/api/product")
        .then(response => {
          this.products = response.data;
          this.selectedProduct = this.products[0].id;
        })
        .catch(error => {
          console.log(error);
        });
      // fetch the system info
      this.axios
        .get("/api/system")
        .then(response => {
          this.system = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      // fetch the user
      this.axios
        .get("/api/user")
        .then(response => {
          this.user = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    logout() {
        this.axios.post('/api/user/logout').then(response => {
            this.$router.push('/login');
        }).catch(error => {
            this.$router.push('/login');
        })
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>

<style lang="scss" scoped>
@import "nav.scss";
</style>



// WEBPACK FOOTER //
// src/components/modules/nav/nav.vue